import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LiveMarketProvider } from "./context/LiveMarketContext";
import { WatchlistProvider } from "./context/WatchlistContext";
import Storefront from "./pages/Storefront";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Library from "./pages/Library";
import Watchlist from "./pages/Watchlist";
import Refer from "./pages/Refer";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";

function ProtectedRoute({ children }) {
  const { user, checked } = useAuth();
  if (!checked || user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-900">
        <Loader2 className="h-6 w-6 animate-spin text-emerald-400" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={
              <WatchlistProvider>
                <LiveMarketProvider>
                  <Storefront />
                </LiveMarketProvider>
              </WatchlistProvider>
            } />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/library" element={<Library />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/refer" element={<Refer />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#1e293b",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#f8fafc",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
